module.exports = __webpack_public_path__ + "static/media/rs.06d57bef.png";